var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup21437(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.915,
    height: 82.795,
    viewBox: "0 0 84.915 82.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21437",
    "data-name": "Group 21437",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21434",
    "data-name": "Group 21434",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M51.057,2,69.54,20.48V72.27a3.669,3.669,0,0,1-3.671,3.663H6.671A3.7,3.7,0,0,1,3,72.266V5.667A3.67,3.67,0,0,1,6.671,2Z",
    transform: "translate(-3 -2)",
    fill: "#3b3b3b"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 20.735,
    cy: 20.735,
    r: 20.735,
    transform: "translate(43.445 41.325)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e664b6fb06572bcc2e016d2138ba8659",
    transform: "translate(58.259 56.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26599",
    "data-name": "Path 26599",
    d: "M12.841,1,1,12.841M1,1,12.841,12.841",
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup21437);
export default __webpack_public_path__ + "static/media/Group 21437.be662a677badd8e232fd01aa59414652.svg";
export { ForwardRef as ReactComponent };